export default "__VITE_ASSET__DplPb7zf__"